import { CitationData } from 'src/citation-generator/types';
import { QuillEditorActionTypes, SelectionEndMenuTypes } from 'src/researcher/models';
import { ContextmenuActionEnum, ContextMenuContainer } from 'src/researcher/types/contextmenu';
import { MousePosition } from 'src/researcher/types/common';

export function updateMousePosition({
  mousePosition,
  contextMenuContainer,
  selectionEndMenu,
}: {
  mousePosition: MousePosition | null;
  contextMenuContainer: ContextMenuContainer | null;
  selectionEndMenu: SelectionEndMenuTypes;
}) {
  return {
    type: ContextmenuActionEnum.UpdateMousePosition,
    payload: { mousePosition, contextMenuContainer, selectionEndMenu },
  };
}

export function updateContextmenuSelectedText({ selectedText }: { selectedText: string }) {
  return {
    type: ContextmenuActionEnum.UpdateSelectedText,
    payload: { selectedText },
  };
}

export function setQuillEditorActionType(quillActionType: QuillEditorActionTypes) {
  return {
    type: ContextmenuActionEnum.SET_QUILL_ACTION_TYPE,
    payload: { quillActionType },
  };
}

export function toggleShouldSearchSelectedText() {
  return {
    type: ContextmenuActionEnum.ToggleShouldSearchSelectedText,
  };
}

export function updateParaphraserMetaData(metaData: CitationData | null = null) {
  return {
    type: ContextmenuActionEnum.UpdateParaphraserMetaData,
    payload: metaData,
  };
}

export function updateSummarizerdMetaData(metaData: CitationData | null = null) {
  return {
    type: ContextmenuActionEnum.UpdateSummarizerdMetaData,
    payload: metaData,
  };
}

export function setMarkerPosition(position: number) {
  return { type: ContextmenuActionEnum.SetMarkerPostion, payload: position };
}

export function setSelectionMetaData(payload: {
  citationData?: CitationData | null;
  selectedText?: string | null;
}) {
  return { type: ContextmenuActionEnum.SetSelectionMetaData, payload };
}

export const resetToInitStateOfContextmenuStateAction = () => ({
  type: ContextmenuActionEnum.ResetStore,
});
